import React, { FC } from 'react'
import LayoutPresenterScreen from './LayoutPresenterScreen'
import { PresenterScreenProps } from './types'
import ParticipantsAudio from '../ParticipantsAudio'
import { mediaType as MediaType } from '@bt-react/constants'
import { ScreenGroup } from '../Screen'
import MutedNotification from '../MutedNotification'
import roles from '../../dataStore/constants/roles'
import WebcamScreen from '../WebcamScreen'

const isSidebarActive = (mediaType: MediaType, mediaLayoutActive: boolean, presenterLayoutActive: boolean) => {

  if (mediaType !== MediaType.SPOTLIGHT && mediaLayoutActive) return true
  if (mediaType === MediaType.SPOTLIGHT && presenterLayoutActive) return true
  return false

}

const PresenterScreen: FC<PresenterScreenProps> = props => {

  const { presenters = [], observers = [], audioMuted } = props

return <>
    {
      props.mediaType === MediaType.WEBCAM ?
      <ScreenGroup>
        {
          !props.focusedPresenter ?
            presenters.map((presenterData) =>
              <WebcamScreen
                key={`screen-item-${presenterData.BTID}`}
                presenter={presenterData}
              />
            ).slice(0, props.maxPresenters)
            :
            <WebcamScreen
              key={`screen-item-${props.focusedPresenter.BTID}`}
              presenter={props.focusedPresenter}
            />
        }
      </ScreenGroup> :
      <LayoutPresenterScreen
        presenters={presenters}
        observers={observers}
        maxPresenters={props.maxPresenters}
        focusedPresenter={props.focusedPresenter}
        screenSharingPresenter={props.screenSharingPresenter}
        mediaType={props.mediaType}
        sideBarActive={isSidebarActive(props.mediaType, props.mediaSidebarActive, props.sidebarActive)}
        isBridgeInstance={props.isBridgeInstance}
        mediaLayoutType={props.mediaLayout}
        autoSpotlight={props.autoSpotlight}
        muted={audioMuted}
      />
    }
    <ParticipantsAudio muted={audioMuted} />
    {!props.isBridgeInstance && props.role && (props.role === roles.PRESENTER || props.role === roles.DIAL_IN) && <MutedNotification/>}
  </>

}

export default PresenterScreen
